import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useBrandManager } from '@/hooks/useBrandManager';

export interface GeneratedImage {
  id: string;
  url: string;
  created_at: string;
}

export const useGeneratedImages = () => {
  const { currentBrandId: brandId } = useBrandManager();

  const { data: images = [], isLoading, error } = useQuery({
    queryKey: ['generated-images', brandId],
    queryFn: async () => {
      if (!brandId) return [];
      
      const { data, error } = await supabase
        .from('os_art_generations')
        .select('id, generated_image_url, created_at')
        .eq('brand_id', brandId)
        .not('generated_image_url', 'is', null)
        .order('created_at', { ascending: false })
        .limit(50);

      if (error) throw error;
      
      return (data || []).map(item => ({
        id: item.id,
        url: item.generated_image_url!,
        created_at: item.created_at,
      })) as GeneratedImage[];
    },
    enabled: !!brandId,
  });

  return {
    images,
    isLoading,
    error,
  };
};
